import React, { Component } from 'react';
import Modal from 'react-modal';
import { connectModal } from 'redux-modal';
import { ENTER_PIN_DIALOG } from '../../../constants';
import EnterPinForm from '../EnterPinForm';
import translate from '../../TranslateHOC';

class EnterPinDialog extends Component {
  constructor() {
    super();
    this.handleConfirmDialog = this.handleConfirmDialog.bind(this);
  }

  handleConfirmDialog() {
    this.props.handleConfirm();
    this.props.handleHide();
  }

  render() {
    const { show, handleHide } = this.props;
    return (
      <Modal
        isOpen={show}
        overlayClassName="dialog__overlay"
        className="dialog__content"
        onRequestClose={handleHide}
        role="dialog"
        ariaHideApp={true}
        contentLabel={this.props.strings.contentWarningChallenge}
      >
        <EnterPinForm
          handleCancel={this.props.handleHide}
          handleConfirm={this.handleConfirmDialog}
          handleForgottenPIN={this.props.handleForgottenPIN}
          contentWarnings={this.props.contentWarnings}
        />
      </Modal>
    );
  }
}

export default translate(
  connectModal({ name: ENTER_PIN_DIALOG, destroyOnHide: true })(EnterPinDialog)
);
